import { DraftProps } from 'container/Home/components/Banners/interface'
import { useState, useEffect } from 'react'
import * as S from './styles'
import { Modal, Tooltip, SlimButton, Icon } from 'components'
import { toast } from 'react-toastify'
import { getUser } from 'commons/utils/user'
import * as DraftOV from 'services/draft'
import { FormatBodyType } from 'container/ManageOrders/utils'

type CheckedDraftVerificationProps = {
  draftsData: DraftProps[]
  getOrdersData: (body?: FormatBodyType) => Promise<void>
  draftsPage: number
}

const CheckedDraftVerification = ({
  draftsData,
  getOrdersData,
  draftsPage
}: CheckedDraftVerificationProps) => {
  const [modalDelete, setModalDelete] = useState(false)
  const [draftsToDelete, setDraftsToDelete] = useState<DraftProps[]>([])

  useEffect(() => {
    if (modalDelete === false) {
      setDraftsToDelete([])
    }
  }, [modalDelete])

  const handleDelete = async () => {
    const itensDraftsToDelete = draftsToDelete.map((draft) => draft.NumeroPedidoRascunho)
    await DraftOV.deleteDraftOV({
      nr_pedi_rasc: itensDraftsToDelete.join(','),
      cd_usua_alte: getUser()
    })
      .then(() => {
        toast.success(
          itensDraftsToDelete.length > 1
            ? 'Os pedidos foram excluídos com sucesso.'
            : 'O pedido foi excluído com sucesso.'
        )
        getOrdersData({ page: draftsPage })
      })
      .catch((error) => {
        toast.error('Não foi possível excluir.')
        console.error(error)
      })
  }

  const checkedsDrafts = draftsData.filter((draft) => draft.checked)
  const completedsOvs =
    checkedsDrafts.filter((draft) => draft.CodigoStatusPedido !== 0).length > 0
  if (checkedsDrafts.length === 0) return <></>

  return (
    <>
      <S.WrapDeleteDraft>
        <S.MessageDeleteButton>
          O que deseja fazer com os itens selecionados?
        </S.MessageDeleteButton>
        <Tooltip
          title={
            completedsOvs ? 'Só é possível excluir pedidos no status "Em aberto".' : ''
          }
        >
          <div>
            <SlimButton
              variant="primary"
              content="Excluir"
              onClick={() => {
                setModalDelete(true)
                setDraftsToDelete(checkedsDrafts)
              }}
              disabled={completedsOvs}
            />
          </div>
        </Tooltip>
      </S.WrapDeleteDraft>
      <Modal
        open={modalDelete}
        setOpen={setModalDelete}
        title={`Excluir pedido${draftsToDelete.length > 1 ? 's' : ''}`}
        description="Todos os materiais dos pedidos abaixo serão excluídos. Deseja continuar?"
        showReturn
        returnText="Voltar"
        buttonIcon={<Icon icon="trash" size="15" />}
        buttonText="Continuar"
        buttonAction={() => {
          handleDelete()
          setDraftsToDelete([])
          setModalDelete(false)
        }}
      >
        <div>
          {draftsToDelete.map((draft) => (
            <p key={draft.NumeroPedidoRascunho}>
              <b>{draft.NumeroPedidoRascunho}</b>
            </p>
          ))}
        </div>
      </Modal>
    </>
  )
}

export default CheckedDraftVerification
